export default __webpack_public_path__ + "static/media/Panayiotis.964ef575.jpg";